import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  loadingView: ({ width, height, styles }) => ({
    display: 'flex',
    width: width || '100vw',
    height: height || '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'var(--root-bg-color)',
    ...(styles || {})
  })
}))

function LoadingView ({ width, height, styles, children }) {
  const classes = useStyles({ width, height, styles })

  return (
    <Box xs={12} className={classes.loadingView}>
      {children}
    </Box>
  )
}

LoadingView.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  styles: PropTypes.object,
  children: PropTypes.node
}

LoadingView.defaultProps = {
  width: undefined,
  height: undefined,
  styles: undefined,
  children: <span className='app-loader' />
}

export default LoadingView
